import { Currency } from "shared/enums/CurrencyEnum";
const config = {
  promineoSiteUrl: "https://www.promineo.com/",
  timePhasingLinkedInUrl: "https://www.linkedin.com/company/timephasing/",
  baseUrl: "https://localhost:44316/api",
  timePhasingApirUrl: "https://localhost:44309/",
  termsAndUsePdfUrl: "https://timephasing.promineo.com/public/Promineo%20General%20Terms%20%20for%20Timephasing.pdf",
  privacyPolicyPdfUrl:"https://timephasing.promineo.com/public/Promineo%20Privacy%20Policy%20for%20Timephasing.pdf",
  defaultProductId: 1,
  defaultLicenseId: 1,
  viewExamplesDocUrl: "./Documentation/ViewExamples.html",
  developersSectionDocUrl: "./Documentation/DevelopersSection.html",
  defaultCurrency: Currency.EUR,
  addGoogleTagManager: false
};

export default config;
